import React, { Component } from "react";
import "../node_modules/bootstrap/dist/css/bootstrap.css";
import "../node_modules/fixed-data-table-2/dist/fixed-data-table.min.css";
import "../src/libs/css/app.css";
import Header from "../src/views/Header";
import SideMenuView from "../src/views/SideMenu/";
import FooterView from "./views/Footer/index";
import ContainerView from "./views/Container/index";
import Toaster from "./components/Toaster/Toaster";
import FloatButton from "./components/FloatButton/FloatButton";
import { fetchRainTax } from "./services/rainTaxService";

class App extends Component {
  state = {
    message: '',
    showToaster: false
  };

  componentDidMount() {
    this.fetchRainTax();
    this.interval = setInterval(this.fetchRainTax, 45000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  fetchRainTax = () => {
    fetchRainTax()
      .then(data => {
        const previousStatus = sessionStorage.getItem('rainTaxStatus');
        const currentStatus = data.status ? 'active' : 'inactive';

        if (previousStatus !== currentStatus) {
          const msg = data.status ? 'Taxa de chuva está ativa' : 'Sem taxa de chuva';
          this.setState({ message: msg, showToaster: true });
          sessionStorage.setItem('rainTaxStatus', currentStatus);
          this.autoCloseToaster();
        }
      })
      .catch(error => {
        console.error('Erro ao buscar taxa de chuva:', error);
      });
  };

  autoCloseToaster = () => {
    setTimeout(() => {
      this.setState({ showToaster: false });
    }, 10000);
  };

  handleCloseToaster = () => {
    this.setState({ showToaster: false });
  };

  handleFloatButtonClick = () => {
    const currentStatus = sessionStorage.getItem('rainTaxStatus');
    const msg = currentStatus === 'active' ? 'Taxa de chuva ativa' : 'Sem taxa de chuva';
    this.setState({ message: msg, showToaster: true });
    this.autoCloseToaster();
  };

  render() {
    return (
      <div>
        {this.state.showToaster && (
          <Toaster message={this.state.message} onClose={this.handleCloseToaster} />
        )}
        <Header />
        <FloatButton onClick={this.handleFloatButtonClick} />
        <SideMenuView />
        <ContainerView>{this.props.children}</ContainerView>
        <FooterView />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js